import { cn } from '../lib/utils'
import tokopediaImg from '../assets/marketplace-tokopedia.png'
import shopeeImg from '../assets/marketplace-shopee.png'
import lazadaImg from '../assets/marketplace-lazada.png'

type MarketplaceImgProps = {
  src: string
  className?: string
}

/** Logo resmi dalam bingkai persegi — `className` mengatur ukuran total (mis. size-8). */
function MarketplaceImg({ src, className }: MarketplaceImgProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center overflow-hidden rounded-[10px] bg-white ring-1 ring-black/[0.08]',
        className
      )}
    >
      <img
        src={src}
        alt=""
        width={64}
        height={64}
        draggable={false}
        className="h-[92%] w-[92%] object-contain select-none"
        aria-hidden
      />
    </span>
  )
}

export function TokopediaIcon({ className }: { className?: string }) {
  return <MarketplaceImg src={tokopediaImg} className={className} />
}

export function ShopeeIcon({ className }: { className?: string }) {
  return <MarketplaceImg src={shopeeImg} className={className} />
}

export function LazadaIcon({ className }: { className?: string }) {
  return <MarketplaceImg src={lazadaImg} className={className} />
}
